export default "__VITE_ASSET__BUWNGzZV__"